import type { FC } from 'react';
import { useRef } from 'react';
import { Transition } from 'react-transition-group';

export type ShimmeringBlurOverlayProps = {
  show?: boolean;
};

/**
 * Blurs the background and adds an animated shimmering effect to show activity.
 *
 * Parent element needs to have `position: relative` for this to work.
 * */
export const ShimmeringBlurOverlay: FC<ShimmeringBlurOverlayProps> = ({ show }) => {
  const nodeRef = useRef(null);

  return (
    <Transition
      nodeRef={nodeRef}
      in={show}
      timeout={{ appear: 200, enter: 200, exit: 100 }}
      unmountOnExit
    >
      {(state) => (
        <div
          ref={nodeRef}
          className={`absolute inset-0 overflow-hidden transition-opacity duration-200 ${state === 'entered' ? 'opacity-100' : 'opacity-0'} z-[1001] backdrop-blur-xs`}
        >
          <div className="shimmering-blur-overlay absolute inset-0" />
        </div>
      )}
    </Transition>
  );
};
